export const NOTIFICATION_SETTINGS = {
    ON: 'On',
    OFF: 'Off',
};

export const getNotificationSetting = isOn => (isOn ? NOTIFICATION_SETTINGS.ON : NOTIFICATION_SETTINGS.OFF);

// List of global routes that the notifications should not be shown on
export const NOTIFICATIONS_GLOBAL_DISALLOWED_ROUTES = [
    '/rent/join',
    '/rent/referrals',
    '/rent/feedback',
    '/login',
    '/unsubscribe',
];

export const NOTIFICATION_IDS = {
    FIT_FEEDBACK: 'fit-feedback',
    ANONYMOUS_EMAIL_SUBSCRIBE: 'anonymous-email-subscribe',
    PDP_ANONYMOUS_EMAIL_SUBSCRIBE: 'pdp-anonymous-email-subscribe',
};

export const AUTHENTICATED_NOTIFICATIONS = [
    NOTIFICATION_IDS.FIT_FEEDBACK,
];

export const ANONYMOUS_NOTIFICATIONS = [
    NOTIFICATION_IDS.ANONYMOUS_EMAIL_SUBSCRIBE,
    NOTIFICATION_IDS.PDP_ANONYMOUS_EMAIL_SUBSCRIBE,
];
